export const translations = {
  tr: {
    translation: {
      // Header
      header: {
        corporate: "Kurumsal",
        services: "Hizmetlerimiz",
        projects: "Projelerimiz",
        getQuote: "Teklif Alın"
      },
      
      // Hero
      hero: {
        title: "30 Yıllık Güvenle, Geleceğin Yapılarını İnşa Ediyoruz.",
        description: "Nesiller boyu süren tecrübemizle, sağlam temeller ve çağdaş çözümlerle projelerinizi hayata geçiriyoruz.",
        cta: "Büyük Proje Teklifi Alın"
      },
      
      // Stats
      stats: {
        years: "Yıl Deneyim",
        projects: "Tamamlanan Proje",
        satisfaction: "Müşteri Memnuniyeti"
      },
      
      // Founder
      founder: {
        subtitle: "Temelinde Güven Var",
        title: "Vizyoner Liderliğimiz",
        paragraph1: "Gedik Group'un sağlam temelleri, kurucumuz <strong>Sayın Orhan Gedik'in</strong> 30 yılı aşkın tecrübesi ve sarsılmaz vizyonu üzerine atılmıştır. İnşaat sektörüne duyduğu tutku ve kaliteye olan adanmışlığıyla Sayın Gedik, Gedik Group'u sadece bir inşaat firması olmaktan çıkarıp, bölgenin en güvenilir ve yenilikçi gayrimenkul geliştiricilerinden biri haline getirmiştir.",
        paragraph2: "Kendisi, sektördeki uzun soluklu deneyimi sayesinde projeleri sadece teknik yeterlilikle değil, aynı zamanda etik değerler ve müşteri odaklılık felsefesiyle yönetmiştir. Orhan Gedik'in <strong>\"Temelinde Güven Var\"</strong> prensibi, grubumuzun DNA'sına işlenmiş bir taahhüttür ve inşa ettiğimiz her yapıda bu liderliğin izlerini görmek mümkündür.",
        quote: "Onun tecrübesi ve öncülüğü, Gedik Group'un geleceğe emin adımlarla yürümesinin en büyük güvencesidir.",
        trust: "Güven",
        trustDesc: "Etik değerler",
        quality: "Kalite",
        qualityDesc: "Mükemmellik tutkusu",
        customerFocus: "Müşteri Odaklılık",
        customerFocusDesc: "Sizin için varız",
        badge: "Yıl Tecrübe"
      },
      
      // Why Gedik
      whyGedik: {
        title: "Neden Gedik Group?",
        subtitle: "Fark Yaratan Özelliklerimiz",
        experience: "30+ Yıl Deneyim",
        experienceDesc: "Sektörde köklü geçmişimiz ve uzmanlığımızla her projede kusursuz hizmet.",
        quality: "Kalite Garantisi",
        qualityDesc: "Her detayda mükemmellik anlayışı ve uluslararası standartlara uygunluk.",
        innovation: "İnovasyon",
        innovationDesc: "En son teknoloji ve çağdaş mimari çözümlerle geleceği inşa ediyoruz.",
        trust: "Güvenilirlik",
        trustDesc: "Zamanında teslim, şeffaf süreç ve müşteri memnuniyeti odaklı yaklaşım."
      },
      
      // Services
      services: {
        title: "Hizmetlerimiz",
        subtitle: "Kapsamlı İnşaat Çözümleri",
        corporate: "Kurumsal Projeler",
        corporateDesc: "Ofis binaları, AVM'ler ve ticari kompleksler için profesyonel çözümler sunuyoruz.",
        residential: "Konut Geliştirme",
        residentialDesc: "Modern yaşam alanları, lüks villa ve konut projeleri ile hayalinizdeki evi inşa ediyoruz.",
        infrastructure: "Altyapı Çözümleri",
        infrastructureDesc: "Kapsamlı altyapı projeleri, yol yapımı ve kentsel dönüşüm hizmetlerimizle şehirleri dönüştürüyoruz.",
        learnMore: "Detaylı Bilgi"
      },
      
      // Process
      process: {
        title: "Projeniz 6 Adımda Nasıl Tamamlanır?",
        subtitle: "Baştan sona şeffaf ve profesyonel süreç",
        step1: "İlk Görüşme",
        step1Desc: "İhtiyaçlarınızı dinliyor, beklentilerinizi anlayarak süreci başlatıyoruz.",
        step2: "Keşif & Analiz",
        step2Desc: "Arsa/alan keşfi yapıyor, teknik analiz ve fizibilite çalışması gerçekleştiriyoruz.",
        step3: "Tasarım & Proje",
        step3Desc: "Mimarlarımız sizin için özel tasarımlar oluşturuyor, onayınıza sunuyoruz.",
        step4: "Sözleşme",
        step4Desc: "Detaylı sözleşme hazırlanıyor, teslim tarihi ve koşullar netlik kazanıyor.",
        step5: "İnşaat & Kontrol",
        step5Desc: "Deneyimli ekibimizle inşaat başlıyor, her aşamada kalite kontrolleri yapılıyor.",
        step6: "Teslim",
        step6Desc: "Projeniz zamanında, eksiksiz ve kullanıma hazır şekilde teslim ediliyor.",
        badge: "Başarıyla Tamamlandı"
      },
      
      // References
      references: {
        title: "Referanslarımız & Ödüllerimiz",
        subtitle: "Güvenilir Ortaklıklar",
        description: "Türkiye'nin önde gelen kurumlarıyla çalışıyor, sektörün en prestijli ödüllerine layık görülüyoruz.",
        corporateTitle: "Kurumsal Referanslarımız",
        awardsTitle: "Ödüller & Sertifikalar"
      },
      
      // Projects
      projects: {
        title: "Proje Galerimiz",
        subtitle: "Villa, konut, AVM ve mimari dizayn projelerimizden seçmeler",
        project1Title: "Lüks Villa Projesi",
        project1Category: "Villa",
        project2Title: "Modern Konut Kompleksi",
        project2Category: "Konut",
        project3Title: "AVM Projesi",
        project3Category: "Ticari",
        project4Title: "Ofis Binası",
        project4Category: "Kurumsal",
        project5Title: "Boğaz Manzaralı Villa",
        project5Category: "Villa",
        project6Title: "Luxury Residence",
        project6Category: "Konut"
      },
      
      // Testimonials
      testimonials: {
        title: "Müşterilerimiz Ne Diyor?",
        subtitle: "Yıllardır süregelen yolculuğumuzda, bizden yalnızca güven değil, aynı zamanda mutluluk ve başarı deneyimi de yaşayan kıymetli müşterilerimiz, sizlere sunduğumuz değeri ve kaliteyi en içten duygularla anlatıyor.",
        items: [
          {
            name: "Ahmet Yılmaz",
            role: "İşletme Sahibi",
            text: "Gedik Group ile çalışmak harika bir deneyimdi. Profesyonellikleri ve kalite standartları çok yüksek. Villa projemiz tam zamanında ve mükemmel bir şekilde tamamlandı. Her aşamada bizi bilgilendirdiler."
          },
          {
            name: "Ayşe Demir",
            role: "Mimar",
            text: "Türkiye'nin en iyi inşaat firmalarından biri olduğunu söyleyebilirim. Konut projemizde her detay düşünülmüş, kullanılan malzemeler birinci sınıf. Ekiplerinin tecrübesi ve deneyimi her hallerinden belli."
          },
          {
            name: "Mehmet Kaya",
            role: "Yönetici",
            text: "AVM projemiz için Gedik Group'u seçtiğimiz için çok memnunuz. Büyük ölçekli projelerde bile mükemmel koordinasyon ve yönetim gösterdiler. Kesinlikle tavsiye ediyorum!"
          }
        ]
      },
      
      // FAQ
      faq: {
        title: "Sıkça Sorulan Sorular",
        subtitle: "Merak Ettikleriniz",
        items: [
          {
            question: "Bir projenin tamamlanma süresi ne kadardır?",
            answer: "Proje süresi, projenin büyüklüğü ve karmaşıklığına bağlıdır. Ortalama bir villa projesi 8-12 ay, konut projesi 12-18 ay, AVM gibi büyük projeler ise 18-24 ay sürebilir. İlk görüşmede size detaylı zaman planı sunuyoruz."
          },
          {
            question: "Garanti süresi ne kadardır?",
            answer: "Tüm projelerimiz için 5 yıl yapısal garanti sağlıyoruz. Ayrıca kullanılan malzemelere göre 2-10 yıl arasında değişen ürün garantileri mevcuttur. Teslim sonrası da 7/24 destek hizmeti sunuyoruz."
          },
          {
            question: "Ödeme planı nasıl işliyor?",
            answer: "Esnek ödeme planları sunuyoruz. Genellikle %30 peşinat, kalan tutar işin aşamalarına göre taksitlendirilir. Arsa karşılığı inşaat, ortak girişim gibi farklı modeller de mevcuttur. Size özel plan hazırlayabiliriz."
          },
          {
            question: "Hangi şehirlerde hizmet veriyorsunuz?",
            answer: "İstanbul başta olmak üzere, Ankara, İzmir, Antalya ve diğer büyük şehirlerde aktif olarak projelerimiz bulunmaktadır. Ayrıca Türkiye'nin her yerinde büyük ölçekli projeler için hizmet verebiliyoruz."
          },
          {
            question: "Kullanılan malzemeler kaliteli mi?",
            answer: "Evet, sadece A+ kalite ve sertifikalı malzemeler kullanıyoruz. Tüm malzemelerimiz TSE, ISO ve CE sertifikalıdır. İsterseniz malzeme seçiminde sizinle birlikte karar verebiliriz."
          },
          {
            question: "Proje tasarımında söz hakkım var mı?",
            answer: "Kesinlikle! Mimarlarımız sizin isteklerinizi dinleyerek özel tasarımlar oluşturur. Tasarım onaylanana kadar revizyon hakkınız vardır. Projeniz sizin hayallerinizin yansımasıdır."
          },
          {
            question: "Ruhsat işlemleri nasıl yapılıyor?",
            answer: "Tüm ruhsat ve izin işlemlerini biz takip ediyoruz. Belediye, çevre şehircilik ve diğer resmi kurumlarla iletişimi biz sağlıyoruz. Siz sadece sürecin bilgilendirilmesini alırsınız."
          },
          {
            question: "İnşaat sürecini takip edebilir miyim?",
            answer: "Evet! Haftalık ilerleme raporları, fotoğraf ve videolar paylaşıyoruz. Ayrıca istediğiniz zaman şantiyeyi ziyaret edebilir, ekibimizle görüşebilirsiniz. Tam şeffaflık ilkemizdir."
          }
        ]
      },
      
      // Contact
      contact: {
        title: "İletişime Geçin",
        subtitle: "Projeleriniz İçin Size Özel Çözümler",
        office: "Ofis",
        mainOffice: "Merkez Ofis",
        branchOffice: "Şube Ofis",
        kocaeliCity: "Kocaeli",
        istanbulCity: "İstanbul",
        workingHours: "Çalışma Saatleri",
        workingHoursTime: "Pzt - Cmt: 09:00 - 18:00",
        emailLabel: "E-posta",
        phoneLabel: "Telefon",
        formTitle: "Bizimle İletişime Geçin",
        formDescription: "Formu doldurun, ekibimiz en kısa sürede sizinle iletişime geçsin.",
        namePlaceholder: "Adınız ve Soyadınız",
        emailPlaceholder: "E-posta Adresiniz",
        phonePlaceholder: "Telefon Numaranız",
        messagePlaceholder: "Mesajınız",
        submit: "WhatsApp ile Gönder",
        successTitle: "Mesajınız İletildi! ✨",
        success: "Ekibimiz en kısa sürede sizinle iletişime geçecek. Teşekkür ederiz!"
      },
      
      // Footer
      footer: {
        description: "30 yıllık güvenle, geleceğin yapılarını inşa ediyoruz. Sağlam temeller ve çağdaş çözümlerle projelerinizi hayata geçiriyoruz.",
        servicesTitle: "Hizmetlerimiz",
        corporateProjects: "Kurumsal Projeler",
        housingDev: "Konut Geliştirme",
        infrastructure: "Altyapı Çözümleri",
        villaProjects: "Villa Projeleri",
        commercial: "Ticari Binalar",
        corporateTitle: "Kurumsal",
        about: "Hakkımızda",
        ourProjects: "Projelerimiz",
        references: "Referanslar",
        career: "Kariyer",
        press: "Basın",
        contactTitle: "İletişim",
        copyright: "Gedik Group. Tüm hakları saklıdır.",
        privacy: "Gizlilik Politikası",
        terms: "Kullanım Koşulları",
        kvkk: "KVKK"
      },
      
      // Newsletter
      newsletter: {
        title: "Projelere Özel Fırsatlar İçin Abone Olun",
        description: "En son projelerimiz, özel kampanyalar ve inşaat sektörü haberleri için e-posta listemize katılın.",
        placeholder: "E-posta adresinizi girin",
        button: "Abone Ol",
        sending: "Gönderiliyor...",
        success: "Başarılı!",
        privacy: "Gizliliğinize saygı duyuyoruz. E-posta adresiniz güvende."
      },

      // Chatbot
      chatbot: {
        title: "Müşteri Danışmanı",
        online: "Çevrimiçi",
        placeholder: "Mesajınızı yazın...",
        footer: "Gedik Group ile güvendesiniz",
        
        // Messages
        welcome: "Merhaba! Ben Gedik Group müşteri danışmanıyım. ✨\n\nSize nasıl yardımcı olabilirim?",
        askProjectType: "Hangi hizmetimizle ilgileniyorsunuz? Lütfen aşağıdakilerden birini seçin:",
        projectSelected: "Harika! {{emoji}} {{projectType}} ile ilgileniyorsunuz.\n\nSizinle iletişime geçebilmemiz için bilgilerinizi alabilir miyim? 😊",
        askFullName: "Ad ve soyad bilginizi alabilir miyim?",
        niceToMeet: "Memnun oldum {{name}}! 🌸",
        askPhone: "Sizinle iletişime geçebilmemiz için telefon numaranızı alabilir miyim?",
        thanks: "Teşekkürler! 💫",
        askProjectDetails: "Son olarak, projeniz hakkında kısaca bilgi verebilir misiniz? (Opsiyonel - İsterseniz 'geç' yazabilirsiniz)",
        allInfoReceived: "Mükemmel! Tüm bilgilerinizi aldık. ✨",
        messageSent: "✅ Mesajınız başarıyla iletildi!\n\nEkibimiz bilgilerinizi aldı ve en kısa sürede sizinle iletişime geçecek. 💚\n\nGedik Group olarak size en iyi hizmeti sunmak için sabırsızlanıyoruz! 🏗️",
        goodbye: "İyi günler dilerim! 🌟",
        notSpecified: "Belirtilmedi",
        
        // Project Types
        projectTypes: {
          villa: "Villa Projesi",
          residential: "Konut Geliştirme",
          corporate: "Kurumsal Bina",
          infrastructure: "Altyapı / Diğer"
        }
      }
    }
  },
  
  en: {
    translation: {
      header: {
        corporate: "Corporate",
        services: "Our Services",
        projects: "Our Projects",
        getQuote: "Get Quote"
      },
      
      hero: {
        title: "Building Tomorrow's Structures with 30 Years of Trust.",
        description: "With generations of experience, we bring your projects to life through solid foundations and contemporary solutions.",
        cta: "Request Major Project Quote"
      },
      
      stats: {
        years: "Years of Experience",
        projects: "Completed Projects",
        satisfaction: "Client Satisfaction"
      },
      
      founder: {
        subtitle: "Trust at the Foundation",
        title: "Our Visionary Leadership",
        paragraph1: "The solid foundations of Gedik Group are built upon the 30+ years of experience and unwavering vision of our founder, <strong>Mr. Orhan Gedik</strong>. With his passion for the construction industry and dedication to quality, Mr. Gedik has transformed Gedik Group from merely a construction company into one of the region's most trusted and innovative real estate developers.",
        paragraph2: "Through his extensive industry experience, he has managed projects not only with technical competence but also with ethical values and a customer-centric philosophy. Orhan Gedik's principle of <strong>\"Trust at the Foundation\"</strong> is a commitment embedded in our group's DNA, and the traces of this leadership can be seen in every structure we build.",
        quote: "His experience and leadership are the greatest assurance of Gedik Group's confident strides into the future.",
        trust: "Trust",
        trustDesc: "Ethical values",
        quality: "Quality",
        qualityDesc: "Passion for excellence",
        customerFocus: "Customer Focus",
        customerFocusDesc: "We exist for you",
        badge: "Years Experience"
      },
      
      whyGedik: {
        title: "Why Gedik Group?",
        subtitle: "Our Distinguishing Features",
        experience: "30+ Years Experience",
        experienceDesc: "Flawless service in every project with our deep industry heritage and expertise.",
        quality: "Quality Guarantee",
        qualityDesc: "Excellence in every detail and compliance with international standards.",
        innovation: "Innovation",
        innovationDesc: "Building the future with cutting-edge technology and contemporary architectural solutions.",
        trust: "Reliability",
        trustDesc: "On-time delivery, transparent process, and customer satisfaction-focused approach."
      },
      
      services: {
        title: "Our Services",
        subtitle: "Comprehensive Construction Solutions",
        corporate: "Corporate Projects",
        corporateDesc: "Professional solutions for office buildings, shopping centers, and commercial complexes.",
        residential: "Residential Development",
        residentialDesc: "Building your dream home with modern living spaces, luxury villas, and residential projects.",
        infrastructure: "Infrastructure Solutions",
        infrastructureDesc: "Transforming cities with comprehensive infrastructure projects, road construction, and urban renewal services.",
        learnMore: "Learn More"
      },
      
      process: {
        title: "How Is Your Project Completed in 6 Steps?",
        subtitle: "Transparent and professional process from start to finish",
        step1: "Initial Meeting",
        step1Desc: "We listen to your needs and understand your expectations to initiate the process.",
        step2: "Discovery & Analysis",
        step2Desc: "Site inspection, technical analysis, and feasibility study are conducted.",
        step3: "Design & Project",
        step3Desc: "Our architects create custom designs for you and present them for approval.",
        step4: "Contract",
        step4Desc: "Detailed contract is prepared, delivery date and conditions are clarified.",
        step5: "Construction & Control",
        step5Desc: "Construction begins with our experienced team, quality controls are performed at every stage.",
        step6: "Delivery",
        step6Desc: "Your project is delivered on time, complete, and ready for use.",
        badge: "Successfully Completed"
      },
      
      references: {
        title: "Our References & Awards",
        subtitle: "Trusted Partnerships",
        description: "Working with Turkey's leading institutions and earning the industry's most prestigious awards.",
        corporateTitle: "Our Corporate References",
        awardsTitle: "Awards & Certificates"
      },
      
      projects: {
        title: "Our Project Gallery",
        subtitle: "Selected works from our villa, residential, shopping center, and architectural design projects",
        project1Title: "Luxury Villa Project",
        project1Category: "Villa",
        project2Title: "Modern Residential Complex",
        project2Category: "Residential",
        project3Title: "Shopping Mall Project",
        project3Category: "Commercial",
        project4Title: "Office Building",
        project4Category: "Corporate",
        project5Title: "Bosphorus View Villa",
        project5Category: "Villa",
        project6Title: "Luxury Residence",
        project6Category: "Residential"
      },
      
      testimonials: {
        title: "What Our Clients Say?",
        subtitle: "Throughout our years-long journey, our valued clients, who have experienced not only trust but also happiness and success with us, share the value and quality we offer with heartfelt emotions.",
        items: [
          {
            name: "Ahmet Yılmaz",
            role: "Business Owner",
            text: "Working with Gedik Group was a wonderful experience. Their professionalism and quality standards are very high. Our villa project was completed on time and perfectly. They kept us informed at every stage."
          },
          {
            name: "Ayşe Demir",
            role: "Architect",
            text: "I can say it's one of Turkey's best construction companies. Every detail was considered in our residential project, the materials used were first-class. The experience and expertise of their teams are evident in everything they do."
          },
          {
            name: "Mehmet Kaya",
            role: "Manager",
            text: "We are very pleased that we chose Gedik Group for our shopping mall project. They showed excellent coordination and management even in large-scale projects. I definitely recommend them!"
          }
        ]
      },
      
      faq: {
        title: "Frequently Asked Questions",
        subtitle: "Your Questions Answered",
        items: [
          {
            question: "How long does it take to complete a project?",
            answer: "Project duration depends on the size and complexity of the project. An average villa project takes 8-12 months, a residential project 12-18 months, and large projects like shopping malls can take 18-24 months. We provide you with a detailed timeline at the first meeting."
          },
          {
            question: "What is the warranty period?",
            answer: "We provide a 5-year structural warranty for all our projects. Additionally, product warranties ranging from 2-10 years are available depending on the materials used. We also offer 24/7 support service after delivery."
          },
          {
            question: "How does the payment plan work?",
            answer: "We offer flexible payment plans. Generally, 30% down payment, the remaining amount is installment based on project stages. Different models such as construction in exchange for land and joint ventures are also available. We can prepare a custom plan for you."
          },
          {
            question: "In which cities do you provide service?",
            answer: "We have active projects in Istanbul, Ankara, Izmir, Antalya, and other major cities. We can also provide services for large-scale projects anywhere in Turkey."
          },
          {
            question: "Are the materials used of high quality?",
            answer: "Yes, we only use A+ quality and certified materials. All our materials are TSE, ISO, and CE certified. If you wish, you can decide on material selection together with us."
          },
          {
            question: "Do I have a say in project design?",
            answer: "Absolutely! Our architects create custom designs by listening to your wishes. You have the right to revisions until the design is approved. Your project is a reflection of your dreams."
          },
          {
            question: "How are permit procedures handled?",
            answer: "We handle all permit and licensing procedures. We communicate with the municipality, environmental urbanism, and other official institutions. You only receive process updates."
          },
          {
            question: "Can I follow the construction process?",
            answer: "Yes! We share weekly progress reports, photos, and videos. You can also visit the construction site and meet with our team anytime. Full transparency is our principle."
          }
        ]
      },
      
      contact: {
        title: "Get in Touch",
        subtitle: "Tailored Solutions for Your Projects",
        office: "Office",
        mainOffice: "Head Office",
        branchOffice: "Branch Office",
        kocaeliCity: "Kocaeli",
        istanbulCity: "Istanbul",
        workingHours: "Working Hours",
        workingHoursTime: "Mon - Sat: 09:00 - 18:00",
        emailLabel: "Email",
        phoneLabel: "Phone",
        formTitle: "Contact Us",
        formDescription: "Fill out the form and our team will contact you shortly.",
        namePlaceholder: "Your Full Name",
        emailPlaceholder: "Your Email Address",
        phonePlaceholder: "Your Phone Number",
        messagePlaceholder: "Your Message",
        submit: "Send via WhatsApp",
        successTitle: "Message Sent! ✨",
        success: "Our team will contact you as soon as possible. Thank you!"
      },
      
      footer: {
        description: "With 30 years of trust, we build tomorrow's structures. Bringing your projects to life with solid foundations and contemporary solutions.",
        servicesTitle: "Our Services",
        corporateProjects: "Corporate Projects",
        housingDev: "Residential Development",
        infrastructure: "Infrastructure Solutions",
        villaProjects: "Villa Projects",
        commercial: "Commercial Buildings",
        corporateTitle: "Corporate",
        about: "About Us",
        ourProjects: "Our Projects",
        references: "References",
        career: "Career",
        press: "Press",
        contactTitle: "Contact",
        copyright: "Gedik Group. All rights reserved.",
        privacy: "Privacy Policy",
        terms: "Terms of Use",
        kvkk: "Data Protection"
      },
      
      newsletter: {
        title: "Subscribe for Exclusive Project Opportunities",
        description: "Join our mailing list for the latest projects, special offers, and construction industry news.",
        placeholder: "Enter your email address",
        button: "Subscribe",
        sending: "Sending...",
        success: "Success!",
        privacy: "We respect your privacy. Your email is secure with us."
      },

      chatbot: {
        title: "Customer Advisor",
        online: "Online",
        placeholder: "Type your message...",
        footer: "You're secure with Gedik Group",
        
        // Messages
        welcome: "Hello! I'm Gedik Group's customer advisor. ✨\n\nHow may I assist you?",
        askProjectType: "Which of our services are you interested in? Please select one below:",
        projectSelected: "Great! {{emoji}} You're interested in {{projectType}}.\n\nMay I get your contact information? 😊",
        askFullName: "May I have your full name?",
        niceToMeet: "Nice to meet you, {{name}}! 🌸",
        askPhone: "May I have your phone number so we can reach you?",
        thanks: "Thank you! 💫",
        askProjectDetails: "Lastly, could you briefly tell us about your project? (Optional - you can type 'skip')",
        allInfoReceived: "Perfect! We've received all your information. ✨",
        messageSent: "✅ Your message has been successfully sent!\n\nOur team has received your information and will contact you as soon as possible. 💚\n\nWe're excited to provide you with the best service at Gedik Group! 🏗️",
        goodbye: "Have a great day! 🌟",
        notSpecified: "Not specified",
        
        // Project Types
        projectTypes: {
          villa: "Villa Project",
          residential: "Residential Development",
          corporate: "Corporate Building",
          infrastructure: "Infrastructure / Other"
        }
      }
    }
  },
  
  ru: {
    translation: {
      header: {
        corporate: "Корпоратив",
        services: "Наши услуги",
        projects: "Наши проекты",
        getQuote: "Получить предложение"
      },
      
      hero: {
        title: "Строим здания будущего с 30-летним доверием.",
        description: "С многолетним опытом мы воплощаем ваши проекты в жизнь через прочные основания и современные решения.",
        cta: "Запросить предложение по крупному проекту"
      },
      
      stats: {
        years: "Лет опыта",
        projects: "Завершенных проектов",
        satisfaction: "Удовлетворенность клиентов"
      },
      
      founder: {
        subtitle: "Доверие в основе",
        title: "Наше дальновидное руководство",
        paragraph1: "Прочный фундамент Gedik Group заложен на основе более чем 30-летнего опыта и непоколебимого видения нашего основателя <strong>господина Орхана Гедика</strong>. Благодаря своей страсти к строительной отрасли и приверженности качеству, господин Гедик превратил Gedik Group из простой строительной компании в одного из самых надежных и инновационных девелоперов недвижимости в регионе.",
        paragraph2: "Благодаря своему обширному отраслевому опыту он управлял проектами не только с технической компетентностью, но и с соблюдением этических ценностей и философии клиентоориентированности. Принцип Орхана Гедика <strong>«Доверие в основе»</strong> - это обязательство, заложенное в ДНК нашей группы, и следы этого лидерства можно увидеть в каждом построенном нами здании.",
        quote: "Его опыт и лидерство - величайшая гарантия уверенного движения Gedik Group в будущее.",
        trust: "Доверие",
        trustDesc: "Этические ценности",
        quality: "Качество",
        qualityDesc: "Страсть к совершенству",
        customerFocus: "Клиентоориентированность",
        customerFocusDesc: "Мы существуем для вас",
        badge: "Лет опыта"
      },
      
      whyGedik: {
        title: "Почему Gedik Group?",
        subtitle: "Наши отличительные особенности",
        experience: "30+ лет опыта",
        experienceDesc: "Безупречный сервис в каждом проекте благодаря глубокому отраслевому наследию и экспертизе.",
        quality: "Гарантия качества",
        qualityDesc: "Совершенство в каждой детали и соответствие международным стандартам.",
        innovation: "Инновации",
        innovationDesc: "Строим будущее с передовыми технологиями и современными архитектурными решениями.",
        trust: "Надежность",
        trustDesc: "Своевременная доставка, прозрачный процесс и подход, ориентированный на удовлетворенность клиентов."
      },
      
      services: {
        title: "Наши услуги",
        subtitle: "Комплексные строительные решения",
        corporate: "Корпоративные проекты",
        corporateDesc: "Профессиональные решения для офисных зданий, торговых центров и коммерческих комплексов.",
        residential: "Жилищное строительство",
        residentialDesc: "Строим дом вашей мечты с современными жилыми пространствами, роскошными виллами и жилыми проектами.",
        infrastructure: "Инфраструктурные решения",
        infrastructureDesc: "Преобразуем города комплексными инфраструктурными проектами, строительством дорог и услугами городского обновления.",
        learnMore: "Подробнее"
      },
      
      process: {
        title: "Как завершается ваш проект за 6 шагов?",
        subtitle: "Прозрачный и профессиональный процесс от начала до конца",
        step1: "Первая встреча",
        step1Desc: "Мы выслушиваем ваши потребности и понимаем ваши ожидания для начала процесса.",
        step2: "Исследование и анализ",
        step2Desc: "Проводится осмотр участка, технический анализ и технико-экономическое обоснование.",
        step3: "Проектирование",
        step3Desc: "Наши архитекторы создают индивидуальные проекты для вас и представляют их на утверждение.",
        step4: "Контракт",
        step4Desc: "Готовится детальный контракт, уточняются сроки сдачи и условия.",
        step5: "Строительство и контроль",
        step5Desc: "Строительство начинается с нашей опытной командой, контроль качества осуществляется на каждом этапе.",
        step6: "Сдача",
        step6Desc: "Ваш проект сдается вовремя, в полном объеме и готовым к использованию.",
        badge: "Успешно завершено"
      },
      
      references: {
        title: "Наши рекомендации и награды",
        subtitle: "Надежные партнерства",
        description: "Работаем с ведущими компаниями Турции и получаем самые престижные награды отрасли.",
        corporateTitle: "Наши корпоративные рекомендации",
        awardsTitle: "Награды и сертификаты"
      },
      
      projects: {
        title: "Галерея наших проектов",
        subtitle: "Избранные работы из наших проектов вилл, жилых домов, торговых центров и архитектурного дизайна",
        project1Title: "Роскошный проект виллы",
        project1Category: "Вилла",
        project2Title: "Современный жилой комплекс",
        project2Category: "Жилой",
        project3Title: "Проект торгового центра",
        project3Category: "Коммерческий",
        project4Title: "Офисное здание",
        project4Category: "Корпоративный",
        project5Title: "Вилла с видом на Босфор",
        project5Category: "Вилла",
        project6Title: "Роскошная резиденция",
        project6Category: "Жилой"
      },
      
      testimonials: {
        title: "Что говорят наши клиенты?",
        subtitle: "На протяжении многолетнего пути наши ценные клиенты, испытавшие с нами не только доверие, но и счастье и успех, делятся ценностью и качеством, которые мы предлагаем, с искренними чувствами.",
        items: [
          { name: "Ahmet Yılmaz", role: "Владелец бизнеса", text: "Работать с Gedik Group было замечательным опытом. Их профессионализм и стандарты качества очень высоки. Наш проект виллы был завершен вовремя и идеально." },
          { name: "Ayşe Demir", role: "Архитектор", text: "Могу сказать, что это одна из лучших строительных компаний Турции. Каждая деталь была продумана в нашем жилом проекте, использованные материалы были первоклассными." },
          { name: "Mehmet Kaya", role: "Менеджер", text: "Мы очень довольны, что выбрали Gedik Group для нашего проекта торгового центра. Они показали отличную координацию и управление даже в крупномасштабных проектах!" }
        ]
      },
      
      faq: {
        title: "Часто задаваемые вопросы",
        subtitle: "Ответы на ваши вопросы",
        items: [
          { question: "Сколько времени занимает завершение проекта?", answer: "Продолжительность проекта зависит от размера и сложности. Средний проект виллы занимает 8-12 месяцев, жилой проект 12-18 месяцев, а крупные проекты могут занять 18-24 месяца." },
          { question: "Каков гарантийный срок?", answer: "Мы предоставляем 5-летнюю структурную гарантию на все наши проекты. Кроме того, доступны гарантии на продукцию от 2 до 10 лет в зависимости от используемых материалов." },
          { question: "Как работает план платежей?", answer: "Мы предлагаем гибкие планы платежей. Обычно 30% первоначальный взнос, остальная сумма в рассрочку в зависимости от этапов проекта." },
          { question: "В каких городах вы предоставляете услуги?", answer: "У нас есть активные проекты в Стамбуле, Анкаре, Измире, Анталье и других крупных городах. Мы также можем предоставлять услуги для крупномасштабных проектов в любой точке Турции." },
          { question: "Материалы высокого качества?", answer: "Да, мы используем только сертифицированные материалы качества A+. Все наши материалы имеют сертификаты TSE, ISO и CE." },
          { question: "Могу ли я участвовать в дизайне проекта?", answer: "Абсолютно! Наши архитекторы создают индивидуальные проекты, прислушиваясь к вашим пожеланиям. У вас есть право на доработки до утверждения проекта." },
          { question: "Как обрабатываются процедуры получения разрешений?", answer: "Мы занимаемся всеми процедурами получения разрешений и лицензий. Вы получаете только обновления о процессе." },
          { question: "Могу ли я следить за процессом строительства?", answer: "Да! Мы делимся еженедельными отчетами о ходе работ, фотографиями и видео. Полная прозрачность - наш принцип." }
        ]
      },
      
      contact: {
        title: "Свяжитесь с нами",
        subtitle: "Индивидуальные решения для ваших проектов",
        office: "Офис",
        mainOffice: "Головной офис",
        branchOffice: "Филиал",
        kocaeliCity: "Коджаэли",
        istanbulCity: "Стамбул",
        workingHours: "Рабочие часы",
        workingHoursTime: "Пн - Сб: 09:00 - 18:00",
        emailLabel: "Электронная почта",
        phoneLabel: "Телефон",
        formTitle: "Свяжитесь с нами",
        formDescription: "Заполните форму, и наша команда свяжется с вами в ближайшее время.",
        namePlaceholder: "Ваше полное имя",
        emailPlaceholder: "Ваш адрес электронной почты",
        phonePlaceholder: "Ваш номер телефона",
        messagePlaceholder: "Ваше сообщение",
        submit: "Отправить через WhatsApp",
        successTitle: "Сообщение отправлено! ✨",
        success: "Наша команда свяжется с вами в ближайшее время. Спасибо!"
      },
      
      footer: {
        description: "С 30-летним доверием строим здания будущего. Воплощаем ваши проекты в жизнь с прочными основаниями и современными решениями.",
        servicesTitle: "Наши услуги",
        corporateProjects: "Корпоративные проекты",
        housingDev: "Жилищное строительство",
        infrastructure: "Инфраструктурные решения",
        villaProjects: "Проекты вилл",
        commercial: "Коммерческие здания",
        corporateTitle: "Корпоратив",
        about: "О нас",
        ourProjects: "Наши проекты",
        references: "Рекомендации",
        career: "Карьера",
        press: "Пресса",
        contactTitle: "Контакты",
        copyright: "Gedik Group. Все права защищены.",
        privacy: "Политика конфиденциальности",
        terms: "Условия использования",
        kvkk: "Защита данных"
      },
      
      newsletter: {
        title: "Подпишитесь на эксклюзивные проектные возможности",
        description: "Присоединяйтесь к нашему списку рассылки, чтобы получать последние проекты, специальные предложения и новости строительной отрасли.",
        placeholder: "Введите ваш адрес электронной почты",
        button: "Подписаться",
        sending: "Отправка...",
        success: "Успешно!",
        privacy: "Мы уважаем вашу конфиденциальность. Ваша электронная почта в безопасности."
      },

      chatbot: {
        title: "Консультант клиентов",
        online: "Онлайн",
        placeholder: "Введите ваше сообщение...",
        footer: "Вы в безопасности с Gedik Group",
        
        welcome: "Здравствуйте! Я консультант Gedik Group. ✨\n\nЧем могу помочь?",
        askProjectType: "Какая из наших услуг вас интересует? Пожалуйста, выберите один из вариантов ниже:",
        projectSelected: "Отлично! {{emoji}} Вы интересуетесь {{projectType}}.\n\nМогу ли я получить вашу контактную информацию? 😊",
        askFullName: "Могу ли я узнать ваше полное имя?",
        niceToMeet: "Приятно познакомиться, {{name}}! 🌸",
        askPhone: "Могу ли я узнать ваш номер телефона, чтобы мы могли с вами связаться?",
        thanks: "Спасибо! 💫",
        askProjectDetails: "Наконец, не могли бы вы кратко рассказать о вашем проекте? (Необязательно - можете пропустить)",
        allInfoReceived: "Отлично! Мы получили всю вашу информацию. ✨",
        messageSent: "✅ Ваше сообщение успешно отправлено!\n\nНаша команда получила вашу информацию и свяжется с вами как можно скорее. 💚\n\nМы рады предоставить вам лучший сервис в Gedik Group! 🏗️",
        goodbye: "Хорошего дня! 🌟",
        notSpecified: "Не указано",
        
        projectTypes: {
          villa: "Проект виллы",
          residential: "Жилой комплекс",
          corporate: "Корпоративное здание",
          infrastructure: "Инфраструктура / Другое"
        }
      }
    }
  },
  
  de: {
    translation: {
      header: {
        corporate: "Unternehmen",
        services: "Unsere Dienstleistungen",
        projects: "Unsere Projekte",
        getQuote: "Angebot erhalten"
      },
      
      hero: {
        title: "Mit 30 Jahren Vertrauen bauen wir die Strukturen von morgen.",
        description: "Mit generationenübergreifender Erfahrung erwecken wir Ihre Projekte durch solide Fundamente und zeitgemäße Lösungen zum Leben.",
        cta: "Großprojekt-Angebot anfordern"
      },
      
      stats: {
        years: "Jahre Erfahrung",
        projects: "Abgeschlossene Projekte",
        satisfaction: "Kundenzufriedenheit"
      },
      
      founder: {
        subtitle: "Vertrauen als Fundament",
        title: "Unsere visionäre Führung",
        paragraph1: "Das solide Fundament der Gedik Group basiert auf über 30 Jahren Erfahrung und der unerschütterlichen Vision unseres Gründers <strong>Herrn Orhan Gedik</strong>. Mit seiner Leidenschaft für die Baubranche und seinem Engagement für Qualität hat Herr Gedik die Gedik Group von einem reinen Bauunternehmen zu einem der vertrauenswürdigsten und innovativsten Immobilienentwickler der Region gemacht.",
        paragraph2: "Durch seine umfangreiche Branchenerfahrung hat er Projekte nicht nur mit technischer Kompetenz, sondern auch mit ethischen Werten und einer kundenorientierten Philosophie geleitet. Orhan Gediks Prinzip <strong>\"Vertrauen als Fundament\"</strong> ist ein Versprechen, das in der DNA unserer Gruppe verankert ist, und die Spuren dieser Führung sind in jedem von uns errichteten Gebäude zu sehen.",
        quote: "Seine Erfahrung und Führung sind die größte Garantie für die zuversichtlichen Schritte der Gedik Group in die Zukunft.",
        trust: "Vertrauen",
        trustDesc: "Ethische Werte",
        quality: "Qualität",
        qualityDesc: "Leidenschaft für Exzellenz",
        customerFocus: "Kundenorientierung",
        customerFocusDesc: "Wir existieren für Sie",
        badge: "Jahre Erfahrung"
      },
      
      whyGedik: {
        title: "Warum Gedik Group?",
        subtitle: "Unsere Unterscheidungsmerkmale",
        experience: "30+ Jahre Erfahrung",
        experienceDesc: "Makellose Dienstleistung in jedem Projekt dank unseres tiefen Branchenerbes und unserer Expertise.",
        quality: "Qualitätsgarantie",
        qualityDesc: "Exzellenz in jedem Detail und Einhaltung internationaler Standards.",
        innovation: "Innovation",
        innovationDesc: "Wir bauen die Zukunft mit modernster Technologie und zeitgenössischen architektonischen Lösungen.",
        trust: "Zuverlässigkeit",
        trustDesc: "Pünktliche Lieferung, transparenter Prozess und kundenorientierter Ansatz."
      },
      
      services: {
        title: "Unsere Dienstleistungen",
        subtitle: "Umfassende Baulösungen",
        corporate: "Unternehmensprojekte",
        corporateDesc: "Professionelle Lösungen für Bürogebäude, Einkaufszentren und Gewerbekomplexe.",
        residential: "Wohnungsbau",
        residentialDesc: "Wir bauen Ihr Traumhaus mit modernen Wohnräumen, Luxusvillen und Wohnprojekten.",
        infrastructure: "Infrastrukturlösungen",
        infrastructureDesc: "Wir transformieren Städte mit umfassenden Infrastrukturprojekten, Straßenbau und Stadterneuerungsdiensten.",
        learnMore: "Mehr erfahren"
      },
      
      process: {
        title: "Wie wird Ihr Projekt in 6 Schritten abgeschlossen?",
        subtitle: "Transparenter und professioneller Prozess von Anfang bis Ende",
        step1: "Erstes Treffen",
        step1Desc: "Wir hören auf Ihre Bedürfnisse und verstehen Ihre Erwartungen, um den Prozess zu beginnen.",
        step2: "Erkundung & Analyse",
        step2Desc: "Standortinspektion, technische Analyse und Machbarkeitsstudie werden durchgeführt.",
        step3: "Design & Projekt",
        step3Desc: "Unsere Architekten erstellen maßgeschneiderte Designs für Sie und präsentieren sie zur Genehmigung.",
        step4: "Vertrag",
        step4Desc: "Detaillierter Vertrag wird erstellt, Liefertermin und Bedingungen werden geklärt.",
        step5: "Bau & Kontrolle",
        step5Desc: "Der Bau beginnt mit unserem erfahrenen Team, Qualitätskontrollen werden in jeder Phase durchgeführt.",
        step6: "Übergabe",
        step6Desc: "Ihr Projekt wird pünktlich, vollständig und nutzungsbereit übergeben.",
        badge: "Erfolgreich abgeschlossen"
      },
      
      references: {
        title: "Unsere Referenzen & Auszeichnungen",
        subtitle: "Vertrauenswürdige Partnerschaften",
        description: "Zusammenarbeit mit führenden Unternehmen der Türkei und Erhalt der prestigeträchtigsten Auszeichnungen der Branche.",
        corporateTitle: "Unsere Unternehmensreferenzen",
        awardsTitle: "Auszeichnungen & Zertifikate"
      },
      
      projects: {
        title: "Unsere Projektgalerie",
        subtitle: "Ausgewählte Arbeiten aus unseren Villa-, Wohn-, Einkaufszentren- und Architekturdesignprojekten",
        project1Title: "Luxus-Villaprojekt",
        project1Category: "Villa",
        project2Title: "Moderner Wohnkomplex",
        project2Category: "Wohnanlage",
        project3Title: "Einkaufszentrum-Projekt",
        project3Category: "Kommerziell",
        project4Title: "Bürogebäude",
        project4Category: "Unternehmen",
        project5Title: "Villa mit Bosporus-Blick",
        project5Category: "Villa",
        project6Title: "Luxus-Residenz",
        project6Category: "Wohnanlage"
      },
      
      testimonials: {
        title: "Was sagen unsere Kunden?",
        subtitle: "Auf unserer langjährigen Reise teilen unsere geschätzten Kunden, die mit uns nicht nur Vertrauen, sondern auch Glück und Erfolg erlebt haben, den Wert und die Qualität, die wir bieten, mit aufrichtigen Gefühlen.",
        items: [
          { name: "Ahmet Yılmaz", role: "Geschäftsinhaber", text: "Die Zusammenarbeit mit Gedik Group war eine wunderbare Erfahrung. Ihre Professionalität und Qualitätsstandards sind sehr hoch. Unser Villaprojekt wurde pünktlich und perfekt fertiggestellt." },
          { name: "Ayşe Demir", role: "Architektin", text: "Ich kann sagen, dass es eines der besten Bauunternehmen der Türkei ist. Jedes Detail wurde in unserem Wohnprojekt berücksichtigt, die verwendeten Materialien waren erstklassig." },
          { name: "Mehmet Kaya", role: "Manager", text: "Wir sind sehr zufrieden, dass wir Gedik Group für unser Einkaufszentrum-Projekt gewählt haben. Sie zeigten hervorragende Koordination und Management auch bei Großprojekten!" }
        ]
      },
      
      faq: {
        title: "Häufig gestellte Fragen",
        subtitle: "Ihre Fragen beantwortet",
        items: [
          { question: "Wie lange dauert die Fertigstellung eines Projekts?", answer: "Die Projektdauer hängt von der Größe und Komplexität ab. Ein durchschnittliches Villaprojekt dauert 8-12 Monate, ein Wohnprojekt 12-18 Monate und große Projekte können 18-24 Monate dauern." },
          { question: "Wie lang ist die Garantiezeit?", answer: "Wir bieten eine 5-jährige strukturelle Garantie für alle unsere Projekte. Zusätzlich sind je nach verwendeten Materialien Produktgarantien von 2-10 Jahren verfügbar." },
          { question: "Wie funktioniert der Zahlungsplan?", answer: "Wir bieten flexible Zahlungspläne an. In der Regel 30% Anzahlung, der Restbetrag wird je nach Projektstufen in Raten gezahlt." },
          { question: "In welchen Städten bieten Sie Dienstleistungen an?", answer: "Wir haben aktive Projekte in Istanbul, Ankara, Izmir, Antalya und anderen Großstädten. Wir können auch Dienstleistungen für Großprojekte überall in der Türkei anbieten." },
          { question: "Sind die verwendeten Materialien von hoher Qualität?", answer: "Ja, wir verwenden nur A+ Qualität und zertifizierte Materialien. Alle unsere Materialien sind TSE-, ISO- und CE-zertifiziert." },
          { question: "Habe ich bei der Projektgestaltung ein Mitspracherecht?", answer: "Absolut! Unsere Architekten erstellen individuelle Designs, indem sie auf Ihre Wünsche hören. Sie haben das Recht auf Überarbeitungen, bis das Design genehmigt ist." },
          { question: "Wie werden Genehmigungsverfahren abgewickelt?", answer: "Wir kümmern uns um alle Genehmigungs- und Lizenzierungsverfahren. Sie erhalten nur Prozessupdates." },
          { question: "Kann ich den Bauprozess verfolgen?", answer: "Ja! Wir teilen wöchentliche Fortschrittsberichte, Fotos und Videos. Volle Transparenz ist unser Prinzip." }
        ]
      },
      
      contact: {
        title: "Kontaktieren Sie uns",
        subtitle: "Maßgeschneiderte Lösungen für Ihre Projekte",
        office: "Büro",
        mainOffice: "Hauptsitz",
        branchOffice: "Zweigstelle",
        kocaeliCity: "Kocaeli",
        istanbulCity: "Istanbul",
        workingHours: "Öffnungszeiten",
        workingHoursTime: "Mo - Sa: 09:00 - 18:00",
        emailLabel: "E-Mail",
        phoneLabel: "Telefon",
        formTitle: "Kontaktieren Sie uns",
        formDescription: "Füllen Sie das Formular aus und unser Team wird Sie in Kürze kontaktieren.",
        namePlaceholder: "Ihr vollständiger Name",
        emailPlaceholder: "Ihre E-Mail-Adresse",
        phonePlaceholder: "Ihre Telefonnummer",
        messagePlaceholder: "Ihre Nachricht",
        submit: "Über WhatsApp senden",
        successTitle: "Nachricht gesendet! ✨",
        success: "Unser Team wird sich in Kürze mit Ihnen in Verbindung setzen. Vielen Dank!"
      },
      
      footer: {
        description: "Mit 30 Jahren Vertrauen bauen wir die Strukturen von morgen. Wir erwecken Ihre Projekte durch solide Fundamente und zeitgemäße Lösungen zum Leben.",
        servicesTitle: "Unsere Dienstleistungen",
        corporateProjects: "Unternehmensprojekte",
        housingDev: "Wohnungsbau",
        infrastructure: "Infrastrukturlösungen",
        villaProjects: "Villaprojekte",
        commercial: "Gewerbegebäude",
        corporateTitle: "Unternehmen",
        about: "Über uns",
        ourProjects: "Unsere Projekte",
        references: "Referenzen",
        career: "Karriere",
        press: "Presse",
        contactTitle: "Kontakt",
        copyright: "Gedik Group. Alle Rechte vorbehalten.",
        privacy: "Datenschutzrichtlinie",
        terms: "Nutzungsbedingungen",
        kvkk: "Datenschutz"
      },
      
      newsletter: {
        title: "Abonnieren Sie exklusive Projektmöglichkeiten",
        description: "Treten Sie unserer Mailingliste bei für die neuesten Projekte, Sonderangebote und Nachrichten aus der Bauindustrie.",
        placeholder: "Geben Sie Ihre E-Mail-Adresse ein",
        button: "Abonnieren",
        sending: "Wird gesendet...",
        success: "Erfolgreich!",
        privacy: "Wir respektieren Ihre Privatsphäre. Ihre E-Mail ist bei uns sicher."
      },

      chatbot: {
        title: "Kundenberater",
        online: "Online",
        placeholder: "Geben Sie Ihre Nachricht ein...",
        footer: "Sie sind sicher mit Gedik Group",
        
        welcome: "Hallo! Ich bin der Kundenberater von Gedik Group. ✨\n\nWie kann ich Ihnen helfen?",
        askProjectType: "Für welche unserer Dienstleistungen interessieren Sie sich? Bitte wählen Sie eine aus:",
        projectSelected: "Großartig! {{emoji}} Sie interessieren sich für {{projectType}}.\n\nDarf ich Ihre Kontaktdaten haben? 😊",
        askFullName: "Darf ich Ihren vollständigen Namen erfahren?",
        niceToMeet: "Schön Sie kennenzulernen, {{name}}! 🌸",
        askPhone: "Darf ich Ihre Telefonnummer haben, damit wir Sie erreichen können?",
        thanks: "Vielen Dank! 💫",
        askProjectDetails: "Könnten Sie uns abschließend kurz über Ihr Projekt erzählen? (Optional - Sie können überspringen)",
        allInfoReceived: "Perfekt! Wir haben alle Ihre Informationen erhalten. ✨",
        messageSent: "✅ Ihre Nachricht wurde erfolgreich gesendet!\n\nUnser Team hat Ihre Informationen erhalten und wird Sie schnellstmöglich kontaktieren. 💚\n\nWir freuen uns darauf, Ihnen bei Gedik Group den besten Service zu bieten! 🏗️",
        goodbye: "Einen schönen Tag noch! 🌟",
        notSpecified: "Nicht angegeben",
        
        projectTypes: {
          villa: "Villa-Projekt",
          residential: "Wohnanlage",
          corporate: "Unternehmensgebäude",
          infrastructure: "Infrastruktur / Sonstiges"
        }
      }
    }
  },
  
  ar: {
    translation: {
      header: {
        corporate: "الشركة",
        services: "خدماتنا",
        projects: "مشاريعنا",
        getQuote: "احصل على عرض"
      },
      
      hero: {
        title: "نبني هياكل الغد بثلاثين عاماً من الثقة.",
        description: "بخبرة امتدت لأجيال، نحيي مشاريعكم من خلال أسس متينة وحلول عصرية.",
        cta: "اطلب عرضاً لمشروع كبير"
      },
      
      stats: {
        years: "سنوات من الخبرة",
        projects: "المشاريع المنجزة",
        satisfaction: "رضا العملاء"
      },
      
      founder: {
        subtitle: "الثقة في الأساس",
        title: "قيادتنا ذات الرؤية",
        paragraph1: "تم وضع الأساس المتين لمجموعة Gedik Group على أكثر من 30 عامًا من الخبرة والرؤية الثابتة لمؤسسنا <strong>السيد أورهان جديك</strong>. من خلال شغفه بصناعة البناء والتزامه بالجودة، حوّل السيد جديك مجموعة Gedik Group من مجرد شركة إنشاءات إلى واحدة من أكثر مطوري العقارات موثوقية وابتكارًا في المنطقة.",
        paragraph2: "من خلال خبرته الواسعة في الصناعة، أدار المشاريع ليس فقط بالكفاءة التقنية ولكن أيضًا بالقيم الأخلاقية وفلسفة تركز على العميل. مبدأ أورهان جديك <strong>\"الثقة في الأساس\"</strong> هو التزام راسخ في الحمض النووي لمجموعتنا، ويمكن رؤية آثار هذه القيادة في كل مبنى نبنيه.",
        quote: "خبرته وقيادته هما أكبر ضمان لخطوات Gedik Group الواثقة نحو المستقبل.",
        trust: "الثقة",
        trustDesc: "القيم الأخلاقية",
        quality: "الجودة",
        qualityDesc: "شغف التميز",
        customerFocus: "التركيز على العميل",
        customerFocusDesc: "نحن موجودون من أجلكم",
        badge: "سنوات من الخبرة"
      },
      
      whyGedik: {
        title: "لماذا Gedik Group؟",
        subtitle: "ميزاتنا المميزة",
        experience: "30+ سنة من الخبرة",
        experienceDesc: "خدمة لا تشوبها شائبة في كل مشروع بفضل تراثنا العميق في الصناعة وخبرتنا.",
        quality: "ضمان الجودة",
        qualityDesc: "التميز في كل التفاصيل والامتثال للمعايير الدولية.",
        innovation: "الابتكار",
        innovationDesc: "نبني المستقبل بأحدث التقنيات والحلول المعمارية المعاصرة.",
        trust: "الموثوقية",
        trustDesc: "التسليم في الوقت المحدد، عملية شفافة ونهج يركز على رضا العملاء."
      },
      
      services: {
        title: "خدماتنا",
        subtitle: "حلول إنشائية شاملة",
        corporate: "المشاريع المؤسسية",
        corporateDesc: "حلول احترافية للمباني المكتبية ومراكز التسوق والمجمعات التجارية.",
        residential: "التطوير السكني",
        residentialDesc: "نبني منزل أحلامكم بمساحات معيشية عصرية وفلل فاخرة ومشاريع سكنية.",
        infrastructure: "حلول البنية التحتية",
        infrastructureDesc: "نحول المدن بمشاريع البنية التحتية الشاملة وبناء الطرق وخدمات التجديد الحضري.",
        learnMore: "المزيد من المعلومات"
      },
      
      process: {
        title: "كيف يتم إنجاز مشروعك في 6 خطوات؟",
        subtitle: "عملية شفافة واحترافية من البداية إلى النهاية",
        step1: "الاجتماع الأولي",
        step1Desc: "نستمع لاحتياجاتكم ونفهم توقعاتكم لبدء العملية.",
        step2: "الاستكشاف والتحليل",
        step2Desc: "يتم إجراء فحص الموقع والتحليل الفني ودراسة الجدوى.",
        step3: "التصميم والمشروع",
        step3Desc: "يقوم مهندسونا المعماريون بإنشاء تصاميم مخصصة لكم ويقدمونها للموافقة.",
        step4: "العقد",
        step4Desc: "يتم إعداد عقد مفصل، ويتم توضيح تاريخ التسليم والشروط.",
        step5: "البناء والرقابة",
        step5Desc: "يبدأ البناء مع فريقنا ذي الخبرة، ويتم إجراء مراقبة الجودة في كل مرحلة.",
        step6: "التسليم",
        step6Desc: "يتم تسليم مشروعكم في الوقت المحدد وبشكل كامل وجاهز للاستخدام.",
        badge: "اكتمل بنجاح"
      },
      
      references: {
        title: "مراجعنا وجوائزنا",
        subtitle: "شراكات موثوقة",
        description: "نعمل مع المؤسسات الرائدة في تركيا ونحصل على أرقى الجوائز في الصناعة.",
        corporateTitle: "مراجعنا المؤسسية",
        awardsTitle: "الجوائز والشهادات"
      },
      
      projects: {
        title: "معرض مشاريعنا",
        subtitle: "أعمال مختارة من مشاريع الفلل والسكن ومراكز التسوق والتصميم المعماري",
        project1Title: "مشروع فيلا فاخرة",
        project1Category: "فيلا",
        project2Title: "مجمع سكني حديث",
        project2Category: "سكني",
        project3Title: "مشروع مركز تسوق",
        project3Category: "تجاري",
        project4Title: "مبنى مكاتب",
        project4Category: "مؤسسي",
        project5Title: "فيلا بإطلالة على البوسفور",
        project5Category: "فيلا",
        project6Title: "مقر فاخر",
        project6Category: "سكني"
      },
      
      testimonials: {
        title: "ماذا يقول عملاؤنا؟",
        subtitle: "على مدار رحلتنا الممتدة لسنوات، يشارك عملاؤنا الكرام الذين اختبروا معنا ليس فقط الثقة، بل أيضاً السعادة والنجاح، القيمة والجودة التي نقدمها بمشاعر صادقة من القلب.",
        items: [
          { name: "Ahmet Yılmaz", role: "صاحب عمل", text: "كانت العمل مع Gedik Group تجربة رائعة. احترافهم ومعايير الجودة عالية جداً. تم الانتهاء من مشروع الفيلا في الوقت المحدد وبشكل مثالي." },
          { name: "Ayşe Demir", role: "مهندسة معمارية", text: "يمكنني القول إنها واحدة من أفضل شركات البناء في تركيا. تم النظر في كل التفاصيل في مشروعنا السكني، والمواد المستخدمة كانت من الدرجة الأولى." },
          { name: "Mehmet Kaya", role: "مدير", text: "نحن سعداء جداً لأننا اخترنا Gedik Group لمشروع مركز التسوق. أظهروا تنسيقاً وإدارة ممتازة حتى في المشاريع الكبيرة!" }
        ]
      },
      
      faq: {
        title: "الأسئلة الشائعة",
        subtitle: "إجابات لأسئلتكم",
        items: [
          { question: "كم من الوقت يستغرق إنجاز المشروع؟", answer: "تعتمد مدة المشروع على الحجم والتعقيد. يستغرق مشروع فيلا متوسط 8-12 شهراً، ومشروع سكني 12-18 شهراً، والمشاريع الكبيرة قد تستغرق 18-24 شهراً." },
          { question: "ما هي فترة الضمان؟", answer: "نقدم ضماناً هيكلياً لمدة 5 سنوات لجميع مشاريعنا. بالإضافة إلى ذلك، تتوفر ضمانات المنتج من 2-10 سنوات اعتماداً على المواد المستخدمة." },
          { question: "كيف تعمل خطة الدفع؟", answer: "نقدم خطط دفع مرنة. عادة 30٪ دفعة أولى، والمبلغ المتبقي بالتقسيط بناءً على مراحل المشروع." },
          { question: "في أي مدن تقدمون الخدمات؟", answer: "لدينا مشاريع نشطة في اسطنبول وأنقرة وإزمير وأنطاليا ومدن رئيسية أخرى. يمكننا أيضاً تقديم خدمات للمشاريع الكبيرة في أي مكان في تركيا." },
          { question: "هل المواد المستخدمة عالية الجودة؟", answer: "نعم، نستخدم فقط مواد معتمدة بجودة A+. جميع موادنا معتمدة من TSE و ISO و CE." },
          { question: "هل لي رأي في تصميم المشروع؟", answer: "بالتأكيد! يقوم مهندسونا المعماريون بإنشاء تصاميم مخصصة من خلال الاستماع إلى رغباتك. لديك الحق في المراجعات حتى يتم الموافقة على التصميم." },
          { question: "كيف يتم التعامل مع إجراءات التصاريح؟", answer: "نحن نتعامل مع جميع إجراءات التصاريح والتراخيص. أنت تتلقى فقط تحديثات العملية." },
          { question: "هل يمكنني متابعة عملية البناء؟", answer: "نعم! نشارك تقارير التقدم الأسبوعية والصور ومقاطع الفيديو. الشفافية الكاملة هي مبدأنا." }
        ]
      },
      
      contact: {
        title: "تواصل معنا",
        subtitle: "حلول مخصصة لمشاريعكم",
        office: "مكتب",
        mainOffice: "المقر الرئيسي",
        branchOffice: "فرع",
        kocaeliCity: "كوجالي",
        istanbulCity: "إسطنبول",
        workingHours: "ساعات العمل",
        workingHoursTime: "الاثنين - السبت: 09:00 - 18:00",
        emailLabel: "البريد الإلكتروني",
        phoneLabel: "الهاتف",
        formTitle: "تواصل معنا",
        formDescription: "املأ النموذج وسيتواصل فريقنا معك قريباً.",
        namePlaceholder: "اسمك الكامل",
        emailPlaceholder: "عنوان بريدك الإلكتروني",
        phonePlaceholder: "رقم هاتفك",
        messagePlaceholder: "رسالتك",
        submit: "إرسال عبر واتساب",
        successTitle: "تم إرسال الرسالة! ✨",
        success: "سيتواصل فريقنا معك في أقرب وقت ممكن. شكراً لك!"
      },
      
      footer: {
        description: "بثلاثين عاماً من الثقة، نبني هياكل الغد. نحيي مشاريعكم من خلال أسس متينة وحلول عصرية.",
        servicesTitle: "خدماتنا",
        corporateProjects: "المشاريع المؤسسية",
        housingDev: "التطوير السكني",
        infrastructure: "حلول البنية التحتية",
        villaProjects: "مشاريع الفلل",
        commercial: "المباني التجارية",
        corporateTitle: "الشركة",
        about: "من نحن",
        ourProjects: "مشاريعنا",
        references: "المراجع",
        career: "الوظائف",
        press: "الصحافة",
        contactTitle: "الاتصال",
        copyright: "Gedik Group. جميع الحقوق محفوظة.",
        privacy: "سياسة الخصوصية",
        terms: "شروط الاستخدام",
        kvkk: "حماية البيانات"
      },
      
      newsletter: {
        title: "اشترك للحصول على فرص مشاريع حصرية",
        description: "انضم إلى قائمتنا البريدية للحصول على أحدث المشاريع والعروض الخاصة وأخبار صناعة البناء.",
        placeholder: "أدخل عنوان بريدك الإلكتروني",
        button: "اشترك",
        sending: "جارٍ الإرسال...",
        success: "نجح!",
        privacy: "نحن نحترم خصوصيتك. بريدك الإلكتروني آمن معنا."
      },

      chatbot: {
        title: "مستشار العملاء",
        online: "متصل",
        placeholder: "اكتب رسالتك...",
        footer: "أنت آمن مع Gedik Group",
        
        welcome: "مرحباً! أنا مستشار Gedik Group. ✨\n\nكيف يمكنني مساعدتك؟",
        askProjectType: "أي من خدماتنا تهمك؟ يرجى اختيار واحدة من الخيارات أدناه:",
        projectSelected: "رائع! {{emoji}} أنت مهتم بـ {{projectType}}.\n\nهل يمكنني الحصول على معلومات الاتصال الخاصة بك؟ 😊",
        askFullName: "هل يمكنني معرفة اسمك الكامل؟",
        niceToMeet: "تشرفنا بمعرفتك، {{name}}! 🌸",
        askPhone: "هل يمكنني الحصول على رقم هاتفك حتى نتمكن من التواصل معك؟",
        thanks: "شكراً لك! 💫",
        askProjectDetails: "أخيراً، هل يمكنك إخبارنا بإيجاز عن مشروعك؟ (اختياري - يمكنك التخطي)",
        allInfoReceived: "ممتاز! لقد استلمنا جميع معلوماتك. ✨",
        messageSent: "✅ تم إرسال رسالتك بنجاح!\n\nلقد استلم فريقنا معلوماتك وسيتواصل معك في أقرب وقت ممكن. 💚\n\nنحن متحمسون لتقديم أفضل خدمة لك في Gedik Group! 🏗️",
        goodbye: "أتمنى لك يوماً سعيداً! 🌟",
        notSpecified: "غير محدد",
        
        projectTypes: {
          villa: "مشروع فيلا",
          residential: "تطوير سكني",
          corporate: "مبنى مؤسسي",
          infrastructure: "بنية تحتية / أخرى"
        }
      }
    }
  }
};
